import classNames from 'classnames';
import { ButtonSize, TextInputSize } from 'lego-on-react';
import * as React from 'react';
import { KeyboardEvent } from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { KeyCode } from '../../../typings/common';
import { ButtonDecorator } from '../../ButtonDecorator/ButtonDecorator';
import { DirectFormInput } from '../../DirectFormInput/DirectFormInput';
import { InputFieldType } from '../../InputField/InputField';

import './PhrasesSelectorWizardInput.css';

export interface PhrasesSelectorWizardInputProps {
    cls?: string;
    value: string;
    onChange: (value: string) => void;
    onSubmit: (value: string) => void;
    placeholder: string;
    buttonText: string;
    buttonSize: ButtonSize;
    inputSize: TextInputSize;
    error?: string;
}

export class PhrasesSelectorWizardInput extends React.PureComponent<PhrasesSelectorWizardInputProps> {
    render() {
        const { value, onChange, placeholder, buttonText, buttonSize, inputSize, cls, error } = this.props;

        return (
            <div className={classNames(cls, Bem.cls('phrases-selector-wizard-input'))}>
                <DirectFormInput
                    cls={Bem.cls('phrases-selector-wizard-input', 'input')}
                    inputType={InputFieldType.TEXT}
                    text={value}
                    theme={'normal'}
                    view={'classic'}
                    size={inputSize}
                    onChange={onChange}
                    onKeyDown={this.onWordInputKeydown}
                    placeholder={placeholder}
                    errorTooltip={{ to: ['bottom'] }}
                    pin={'brick-clear'}
                    valid={!error}
                    errorText={error}
                />
                <ButtonDecorator
                    cls={Bem.cls('phrases-selector-wizard-input', 'button')}
                    theme={'action'}
                    size={buttonSize}
                    disabled={!!error}
                    width={'max'}
                    text={buttonText}
                    onClick={this.onSubmit}
                    pin={'clear-round'}
                />
            </div>
        );
    }

    private onSubmit = () => {
        const { onSubmit, value } = this.props;
        onSubmit(value);
    };

    private onWordInputKeydown = (e: KeyboardEvent<HTMLDivElement>) => {
        const code = e.keyCode;

        if (code === KeyCode.RETURN) {
            this.onSubmit();
        }
    };
}
